// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  site_name: "crestDB",
  description: "crestDB is an open and extendable drug repurposing database and screening set of over 12,000 compounds",
  api_url: 'http://172.29.28.222:8080/api',
  host_url: 'http://172.29.28.222:8080', 
  url: 'http://172.29.28.222:8080',
  googleAnalyticsKey: ''
};